import axios from 'axios';
import { getToken, removeToken } from '@/utils/auth';
import { Message } from 'element-ui';
import router from '@/router';
import apiConfig from '@/config/api'

// 创建 axios 实例
const service = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: 50000
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 添加 Token
    if (getToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    }
    return config;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data || response;
    if (res && typeof res.code !== 'undefined') {
      if (res.code !== 200) {
        Message.error(res.error || res.message || '请求失败');
        if (res.code === 401) {
          removeToken();
          router.push('/login');
        }
        return Promise.reject(res);
      }
      return res;
    }
    return { code: 200, data: res };
  },
  (error) => {
    console.error('响应错误:', error);
    Message.error(error.message || '服务器错误');
    
    // 401/403 处理
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      removeToken();
      router.push('/login');
    }
    
    return Promise.reject(error);
  }
);

export default service;
